import React from "react";

const PrivacyGlossy = () => {
  return (
    <svg
      width="196"
      height="79"
      viewBox="0 0 196 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M78.7481 -88.2329L81.4692 -82.3967C82.738 -79.6752 85.9827 -78.5021 88.7043 -79.771C115.86 -92.4321 148.236 -80.7274 160.897 -53.5715C173.558 -26.4156 161.808 5.86252 134.652 18.5236L125.462 22.8087M117.051 -6.08057L122.399 -8.57439C134.775 -14.3442 139.953 -29.2612 133.961 -41.5303C128.103 -53.5242 113.712 -58.7969 101.555 -53.2847L91.4452 -48.7005M58.1968 -33.6244L55.5876 -32.4414C36.1782 -23.6404 27.6854 -0.688818 36.6909 18.6265L37.3282 19.9934C46.6152 39.9123 70.2912 48.5312 90.2101 39.2443L92.2149 38.3095"
        stroke="#237BFF"
        strokeWidth="11.4465"
        strokeLinecap="round"
      />
      <path
        d="M115.767 46.0588C107.233 50.0375 97.0424 46.3292 93.0266 37.716C89.0108 29.1028 92.7219 18.9128 101.256 14.934C109.789 10.9552 119.98 14.6636 123.996 23.2768C128.012 31.89 124.301 42.08 115.767 46.0588Z"
        stroke="#237BFF"
        strokeWidth="11.4465"
      />
      <path
        d="M71.8602 32.8592C74.8279 43.971 78.3281 54.065 88.2638 60.6195"
        stroke="#237BFF"
        strokeWidth="11.4465"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default PrivacyGlossy;
